export const SET_CURRENT = 'SET_CURRENT';
export const UPDATE = 'UPDATE';
